var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$apollo.queries.url.loading)?_c('div',{staticClass:"loading"},[_c('Loader',{attrs:{"size":"20"}})],1):_c('div',{staticClass:"link"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank","download":""}},[_c('img',{attrs:{"src":require("../assets/icons/Attach-File.svg")}}),_c('span',[_vm._v(_vm._s(_vm.file.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }